import BotonManualHeader from "../../components/BotonManualHeader";
import React, { useState, useEffect } from "react";

import {
    Container,
    Card,
    Form,
    Button,
    Row,
    Col,
    Table,
    Spinner,
    Badge,
    Alert,
    Modal,
    InputGroup,
    OverlayTrigger,
    Tooltip
} from "react-bootstrap";
import {
    FaSave,
    FaPlus,
    FaEdit,
    FaTrash,
    FaFileAlt,
    FaArrowUp,
    FaArrowDown,
    FaExclamationTriangle,
    FaSearch,
    FaUpload,
    FaSignature,
    FaCog,
    FaInfoCircle,
    FaList,
    FaTimes,
    FaCheckCircle
} from "react-icons/fa";
import {
    getFirestore,
    collection,
    getDocs,
    doc,
    setDoc,
    deleteDoc,
    serverTimestamp,
    writeBatch
} from "firebase/firestore";
import firebaseApp from "../../firebase/credenciales";
import Swal from "sweetalert2";

const db = getFirestore(firebaseApp);

// Tipos de documentos disponibles
const TIPOS_DOCUMENTO = [
    { valor: "upload", texto: "Carga de documento", icono: <FaUpload /> },
    { valor: "sign", texto: "Firma digital", icono: <FaSignature /> },
    { valor: "fill", texto: "Formulario para llenar", icono: <FaEdit /> } // Nuevo tipo
];

function ListaMaestra({ usuario }) {
    // Estados
    const [documentos, setDocumentos] = useState([]);
    const [documentoEditando, setDocumentoEditando] = useState(null);
    const [loading, setLoading] = useState(true);
    const [guardando, setGuardando] = useState(false);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [nuevoDocumento, setNuevoDocumento] = useState({
        title: "",
        obligatorio: true,
        type: "upload" // Por defecto es upload
    });
    const [searchTerm, setSearchTerm] = useState("");
    const [documentosModificados, setDocumentosModificados] = useState(false);

    // Obtener la lista de documentos al cargar
    useEffect(() => {
        cargarDocumentos();
    }, [usuario.ruc]);

    // Función para cargar documentos
    const cargarDocumentos = async () => {
        try {
            setLoading(true);
            const rucEmpresa = usuario.ruc || "20538856674";

            const documentosRef = collection(db, `onboarding_lista/${rucEmpresa}/documentos`);
            const documentosSnap = await getDocs(documentosRef);

            const listaDocumentos = [];
            documentosSnap.forEach((doc) => {
                listaDocumentos.push({
                    id: doc.id,
                    ...doc.data()
                });
            });

            // Ordenar documentos por ID (asumiendo que son numéricos)
            listaDocumentos.sort((a, b) => parseInt(a.id) - parseInt(b.id));

            // Si no hay documentos, usar lista predefinida
            if (listaDocumentos.length === 0) {
                const listaPredefinida = generarListaPredefinida();
                setDocumentos(listaPredefinida);
            } else {
                setDocumentos(listaDocumentos);
            }

            setDocumentosModificados(false);
        } catch (error) {
            console.error("Error al cargar documentos:", error);
            setError("Error al cargar la lista de documentos");
        } finally {
            setLoading(false);
        }
    };

    // Generar lista predefinida de documentos
    const generarListaPredefinida = () => {
        const listaDocumentos = [
            { nombre: "Aprobación de Empleo", tipo: "upload" },
            { nombre: "Perfil de cargo", tipo: "upload" },
            { nombre: "Ficha de Ingreso del trabajador", tipo: "upload" },
            { nombre: "Declaración Jurada de Domicilio", tipo: "sign" },
            { nombre: "Declaración Jurada de Quinta Categoría o certificado de 5ta", tipo: "sign" },
            { nombre: "Declaración Jurada de apertura para pago de Remuneración", tipo: "sign" },
            { nombre: "Convenio de Confidencialidad", tipo: "sign" },
            { nombre: "Autorización para uso de datos personales", tipo: "sign" },
            { nombre: "Consentimiento Informado (realización de exámenes médicos)", tipo: "sign" },
            { nombre: "Compromiso de Responsabilidad con los bienes", tipo: "sign" },
            { nombre: "Carta de Compromiso (Vigilancia de salud)", tipo: "sign" },
            { nombre: "Declaración jurada de beneficiarios - Vida Ley", tipo: "sign" },
            { nombre: "Convenio de entrega Digital de Documentos Laborales", tipo: "sign" },
            { nombre: "Declaración de Exoneración de responsabilidad", tipo: "sign" },
            { nombre: "DNI del trabajador (copia)", tipo: "upload" },
            { nombre: "Certificado de Unión de Hecho o Matrimonio", tipo: "upload" },
            { nombre: "DNI Hijos o Partida de Nacimiento de Hijos", tipo: "upload" },
            { nombre: "DNI de esposa/concubina (o)", tipo: "upload" },
            { nombre: "Foto tamaño carnet o pasaporte", tipo: "upload" },
            { nombre: "Curriculum Vitae", tipo: "upload" },
            { nombre: "Certificados de trabajo", tipo: "upload" },
            { nombre: "Certificado Habilitación", tipo: "upload" },
            { nombre: "Carta de aviso de egresado", tipo: "upload" },
            { nombre: "Certificado Antecedentes Penales", tipo: "upload" },
            { nombre: "Certificado de Antecedentes Policiales", tipo: "upload" },
            { nombre: "Lista de chequeo de HV", tipo: "upload" },
            { nombre: "Informe final de Reclutamiento", tipo: "upload" },
            { nombre: "Prueba de Conocimiento Específico", tipo: "upload" },
            { nombre: "Prueba de HSEQ", tipo: "upload" },
            { nombre: "Entrevista Jefe directo", tipo: "upload" },
            { nombre: "Informe Disc", tipo: "upload" },
            { nombre: "Constancia de aptitud de médica", tipo: "upload" },
            { nombre: "T-Registro", tipo: "upload" },
            { nombre: "Recibo de Manual de Funciones", tipo: "sign" },
            { nombre: "Carta de aviso personal de Confianza y Dirección", tipo: "sign" },
            { nombre: "Aviso de tercerización", tipo: "sign" },
            { nombre: "Contratos", tipo: "sign" },
            { nombre: "Plan de Capacitación", tipo: "sign" },
            { nombre: "Boletín Informativo de Sistema de Pensiones", tipo: "sign" },
            { nombre: "Reglamento Interno de Trabajo", tipo: "sign" },
            { nombre: "Reglamento de seguridad y salud en el trabajo", tipo: "sign" },
            { nombre: "Hoja de Ruta", tipo: "upload" },
            { nombre: "Inducción de Talento Humano", tipo: "upload" },
            { nombre: "Inducción de Seguridad (HSEQ)", tipo: "upload" },
            { nombre: "IPER por puesto de trabajo", tipo: "upload" },
            { nombre: "Carta Compromiso / Inducción de la vigilancia a la gestación", tipo: "sign" },
            { nombre: "Charla y/o Inducción sobre Hostigamiento Sexual", tipo: "upload" }
        ].map((item, index) => ({
            id: (index + 1).toString(),
            title: item.nombre,
            obligatorio: true,
            activo: true,
            type: item.tipo
        }));

        return listaDocumentos;
    };

    // Manejar cambio en el campo de obligatorio
    const handleObligatorioChange = (id, checked) => {
        setDocumentos(docs =>
            docs.map(doc =>
                doc.id === id ? { ...doc, obligatorio: checked } : doc
            )
        );
        setDocumentosModificados(true);
    };

    // Manejar cambio en el tipo de documento
    const handleTipoChange = (id, tipo) => {
        setDocumentos(docs =>
            docs.map(doc =>
                doc.id === id ? { ...doc, type: tipo } : doc
            )
        );
        setDocumentosModificados(true);
    };

    // Abrir modal para editar documento
    const editarDocumento = (documento) => {
        setDocumentoEditando({ ...documento });
        setShowModal(true);
    };

    // Guardar cambios del documento en edición
    const guardarEdicion = () => {
        if (!documentoEditando.title.trim()) {
            Swal.fire({
                title: "Error",
                text: "El título del documento no puede estar vacío",
                icon: "error"
            });
            return;
        }

        setDocumentos(docs =>
            docs.map(doc =>
                doc.id === documentoEditando.id ? { ...documentoEditando } : doc
            )
        );

        setShowModal(false);
        setDocumentosModificados(true);
    };

    // Añadir nuevo documento
    const agregarDocumento = () => {
        if (!nuevoDocumento.title.trim()) {
            setError("El nombre del documento no puede estar vacío");
            return;
        }

        // Generar ID para el nuevo documento
        const nuevoId = (documentos.length + 1).toString();

        const nuevoDoc = {
            id: nuevoId,
            title: nuevoDocumento.title,
            obligatorio: nuevoDocumento.obligatorio,
            activo: true,
            type: nuevoDocumento.type
        };

        setDocumentos([...documentos, nuevoDoc]);
        setNuevoDocumento({ title: "", obligatorio: true, type: "upload" });
        setDocumentosModificados(true);

        Swal.fire({
            title: "Documento agregado",
            text: "El documento se agregó a la lista",
            icon: "success",
            timer: 1500,
            showConfirmButton: false
        });
    };

    // Eliminar documento
    const eliminarDocumento = (id) => {
        Swal.fire({
            title: "¿Eliminar documento?",
            text: "Esta acción no se puede deshacer",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar"
        }).then((result) => {
            if (result.isConfirmed) {
                setDocumentos(docs => docs.filter(doc => doc.id !== id));
                setDocumentosModificados(true);

                Swal.fire({
                    title: "Eliminado",
                    text: "El documento ha sido eliminado",
                    icon: "success",
                    timer: 1500,
                    showConfirmButton: false
                });
            }
        });
    };

    // Mover documento hacia arriba
    const moverArriba = (index) => {
        if (index === 0) return;

        const nuevosDocumentos = [...documentos];
        const temp = nuevosDocumentos[index];
        nuevosDocumentos[index] = nuevosDocumentos[index - 1];
        nuevosDocumentos[index - 1] = temp;

        // Actualizar IDs para mantener el orden
        const reordenados = nuevosDocumentos.map((doc, idx) => ({
            ...doc,
            id: (idx + 1).toString()
        }));

        setDocumentos(reordenados);
        setDocumentosModificados(true);
    };

    // Mover documento hacia abajo
    const moverAbajo = (index) => {
        if (index === documentos.length - 1) return;

        const nuevosDocumentos = [...documentos];
        const temp = nuevosDocumentos[index];
        nuevosDocumentos[index] = nuevosDocumentos[index + 1];
        nuevosDocumentos[index + 1] = temp;

        // Actualizar IDs para mantener el orden
        const reordenados = nuevosDocumentos.map((doc, idx) => ({
            ...doc,
            id: (idx + 1).toString()
        }));

        setDocumentos(reordenados);
        setDocumentosModificados(true);
    };

    // Guardar lista completa en Firestore
    const guardarListaMaestra = async () => {
        try {
            setGuardando(true);
            const rucEmpresa = usuario.ruc || "20538856674";

            // Confirmar guardado
            const confirmacion = await Swal.fire({
                title: "Guardar lista maestra",
                text: "¿Deseas guardar los cambios en la lista maestra de documentos?",
                icon: "question",
                showCancelButton: true,
                confirmButtonText: "Sí, guardar",
                cancelButtonText: "Cancelar"
            });

            if (!confirmacion.isConfirmed) {
                setGuardando(false);
                return;
            }

            // Crear un batch para operaciones en lote
            const batch = writeBatch(db);

            // Eliminar todos los documentos existentes
            const documentosRef = collection(db, `onboarding_lista/${rucEmpresa}/documentos`);
            const documentosExistentes = await getDocs(documentosRef);

            documentosExistentes.forEach(documento => {
                batch.delete(documento.ref);
            });

            // Guardar los documentos actualizados
            documentos.forEach((documento, index) => {
                const id = (index + 1).toString();
                const docRef = doc(db, `onboarding_lista/${rucEmpresa}/documentos`, id);

                batch.set(docRef, {
                    ...documento,
                    id,
                    actualizadoPor: usuario.email || usuario.nombre,
                    actualizadoEl: serverTimestamp()
                });
            });

            // Ejecutar el batch
            await batch.commit();

            setDocumentosModificados(false);

            Swal.fire({
                title: "¡Lista guardada!",
                text: `Se actualizaron ${documentos.length} documentos en la lista maestra`,
                icon: "success"
            });
        } catch (error) {
            console.error("Error al guardar lista maestra:", error);
            Swal.fire({
                title: "Error",
                text: "Hubo un problema al guardar la lista maestra",
                icon: "error"
            });
        } finally {
            setGuardando(false);
        }
    };

    // Obtener icono y color según tipo de documento
    const getTipoDocumentoInfo = (tipo) => {
        switch (tipo) {
            case "sign":
                return {
                    icono: <FaSignature />,
                    texto: "Firma digital",
                    color: "info"
                };
            case "fill":
                return {
                    icono: <FaEdit />,
                    texto: "Formulario para llenar",
                    color: "warning"
                };
            case "upload":
            default:
                return {
                    icono: <FaUpload />,
                    texto: "Carga de documento",
                    color: "secondary"
                };
        }
    };

    // Filtrar documentos según el término de búsqueda
    const documentosFiltrados = documentos.filter(
        doc => doc.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div
            className="min-vh-100"
            style={{
                background: "linear-gradient(135deg, #ffffff 0%, #ffffff 100%)",
                minHeight: "100vh",
                width: "100vw",
                maxWidth: "100%",
                padding: "20px 0",
            }}
        >
            <Container fluid style={{ width: "90%", maxWidth: "100%" }}>
                {/* Marco principal */}
                <Card
                    className="shadow-lg border-0"
                    style={{
                        borderRadius: "15px",
                        overflow: "hidden",
                        minHeight: "90vh",
                    }}
                >
                    {/* Header Premium */}
                    <Card.Header
                        className="text-white py-4 position-relative"
                        style={{
                            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                            borderBottom: "3px solid #f39c12",
                        }}
                    >
                        <div style={{position:"relative",display:"flex",alignItems:"center",justifyContent:"center"}} className="w-100">

                            <div className="text-center">
                                <h2 className="fw-bold mb-1">
                                    <FaList className="me-3" />
                                    Lista Maestra de Documentos
                                </h2>
                                <p className="mb-0 opacity-75">
                                    Catálogo maestro de documentos para el proceso de onboarding
                                </p>
                            </div>
                            <div style={{position:"absolute",right:"20px"}}>
                                <BotonManualHeader usuario={usuario} />
                            </div>
                        </div>
                    </Card.Header>

                    <Card.Body className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
                        {/* Barra superior con acciones */}
                        <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: "15px" }}>
                            <Card.Body className="p-4">
                                <Row className="align-items-center">
                                    <Col md={1}>
                                        <div
                                            className="rounded-3 p-3 text-center"
                                            style={{
                                                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                                color: "white"
                                            }}
                                        >
                                            <FaCog size={24} />
                                        </div>
                                    </Col>
                                    <Col md={7}>
                                        <h5 className="mb-1 fw-semibold">Catálogo de Documentos</h5>
                                        <p className="text-muted mb-0 small">
                                            Administra los documentos que se usarán para todos los usuarios
                                        </p>
                                    </Col>
                                    <Col md={4} className="text-end">
                                        <div className="d-flex gap-2 justify-content-end">
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={<Tooltip>Agregar nuevo documento</Tooltip>}
                                            >
                                                <Button
                                                    variant="outline-success"
                                                    className="d-flex align-items-center"
                                                    onClick={() => {
                                                        setDocumentoEditando(null);
                                                        setShowModal(true);
                                                    }}
                                                    disabled={loading || guardando}
                                                    style={{ borderRadius: "10px" }}
                                                >
                                                    <FaPlus className="me-2" />
                                                    Agregar
                                                </Button>
                                            </OverlayTrigger>

                                            <Button
                                                variant="primary"
                                                className="d-flex align-items-center"
                                                onClick={guardarListaMaestra}
                                                disabled={loading || guardando || !documentosModificados}
                                                style={{
                                                    borderRadius: "10px",
                                                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                                    border: "none",
                                                }}
                                            >
                                                {guardando ? (
                                                    <>
                                                        <Spinner animation="border" size="sm" className="me-2" />
                                                        Guardando...
                                                    </>
                                                ) : (
                                                    <>
                                                        <FaSave className="me-2" />
                                                        Guardar Lista
                                                    </>
                                                )}
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>

                        {/* Estado de cambios pendientes */}
                        {documentosModificados && (
                            <Alert variant="warning" className="border-0 shadow-sm mb-4" style={{ borderRadius: "10px" }}>
                                <div className="d-flex align-items-center">
                                    <FaExclamationTriangle className="me-3 fs-4" />
                                    <div>
                                        <h6 className="fw-bold mb-1">Tienes cambios sin guardar</h6>
                                        <p className="mb-0">Presiona "Guardar Lista" para aplicar los cambios.</p>
                                    </div>
                                </div>
                            </Alert>
                        )}

                        {/* Errores */}
                        {error && (
                            <Alert variant="danger" className="border-0 shadow-sm mb-4" style={{ borderRadius: "10px" }}>
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <FaExclamationTriangle className="me-3 fs-4" />
                                        <div>
                                            <h6 className="fw-bold mb-1">Error</h6>
                                            <p className="mb-0">{error}</p>
                                        </div>
                                    </div>
                                    <Button
                                        variant="link"
                                        size="sm"
                                        onClick={() => setError(null)}
                                        className="text-danger p-0"
                                    >
                                        <FaTimes />
                                    </Button>
                                </div>
                            </Alert>
                        )}

                        {/* Loading inicial */}
                        {loading && (
                            <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: "15px" }}>
                                <Card.Body className="py-5">
                                    <div className="text-center">
                                        <Spinner animation="border" variant="primary" style={{ width: "3rem", height: "3rem" }} />
                                        <h5 className="mt-3 text-muted">Cargando documentos...</h5>
                                        <p className="text-muted">Consultando la lista maestra de documentos</p>
                                    </div>
                                </Card.Body>
                            </Card>
                        )}

                        {/* Contenido principal */}
                        {!loading && (
                            <>
                                {/* Barra de búsqueda */}
                                <Card className="shadow-sm border-0 mb-4" style={{ borderRadius: "15px" }}>
                                    <Card.Body className="p-3">
                                        <Row className="align-items-center">
                                            <Col md={6}>
                                                <InputGroup style={{ borderRadius: "10px" }}>
                                                    <InputGroup.Text style={{ borderRadius: "10px 0 0 10px" }}>
                                                        <FaSearch />
                                                    </InputGroup.Text>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Buscar documento..."
                                                        value={searchTerm}
                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                        style={{ borderRadius: "0 10px 10px 0" }}
                                                    />
                                                </InputGroup>
                                            </Col>
                                            <Col md={6}>
                                                <div className="d-flex gap-3 justify-content-end">
                                                    <div className="d-flex align-items-center">
                                                        <Badge bg="secondary" className="me-2 py-1 px-2">
                                                            <FaUpload className="me-1" />
                                                        </Badge>
                                                        <span className="small">Carga de documento</span>
                                                    </div>
                                                    <div className="d-flex align-items-center">
                                                        <Badge bg="info" className="me-2 py-1 px-2">
                                                            <FaSignature className="me-1" />
                                                        </Badge>
                                                        <span className="small">Firma digital</span>
                                                    </div>
                                                    <div className="d-flex align-items-center">
                                                        <Badge bg="warning" className="me-2 py-1 px-2">
                                                            <FaEdit className="me-1" />
                                                        </Badge>
                                                        <span className="small">Formulario</span>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>

                                {/* Tabla de documentos */}
                                <Card className="border-0 shadow-sm mb-4" style={{ borderRadius: "15px" }}>
                                    <Card.Header className="bg-primary text-white py-3">
                                        <div className="d-flex align-items-center">
                                            <FaFileAlt className="me-2" />
                                            <div className="flex-grow-1">
                                                <h5 className="mb-0 fw-semibold">Lista de Documentos</h5>
                                                <small className="opacity-75">
                                                    Gestiona todos los documentos del proceso de onboarding
                                                </small>
                                            </div>
                                            <div className="d-flex align-items-center gap-2">
                                                <Badge bg="light" text="primary" style={{ fontSize: "0.9rem" }}>
                                                    {documentos.length} documentos
                                                </Badge>
                                            </div>
                                        </div>
                                    </Card.Header>

                                    <Card.Body className="p-0">
                                        <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
                                            <Table hover responsive className="mb-0" style={{ fontSize: "0.9rem" }}>
                                                <thead 
                                                    style={{
                                                        backgroundColor: "#f8f9fa",
                                                        position: "sticky",
                                                        top: 0,
                                                        zIndex: 10,
                                                    }}
                                                >
                                                    <tr>
                                                        <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '8%' }}>
                                                            ID
                                                        </th>
                                                        <th className="border-0 py-3 px-3 text-secondary fw-semibold" style={{ width: '40%' }}>
                                                            Documento
                                                        </th>
                                                        <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '15%' }}>
                                                            Tipo
                                                        </th>
                                                        <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '15%' }}>
                                                            Obligatorio
                                                        </th>
                                                        <th className="border-0 py-3 px-3 text-secondary fw-semibold text-center" style={{ width: '22%' }}>
                                                            Acciones
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {documentosFiltrados.map((doc, index) => {
                                                        const tipoInfo = getTipoDocumentoInfo(doc.type);
                                                        const indexOriginal = documentos.findIndex(d => d.id === doc.id);

                                                        return (
                                                            <tr key={doc.id}>
                                                                <td className="text-center py-3 px-3">
                                                                    <Badge bg="dark" className="px-2 py-1">
                                                                        {doc.id}
                                                                    </Badge>
                                                                </td>
                                                                <td className="py-3 px-3">
                                                                    <div className="d-flex align-items-center">
                                                                        <div className="me-3">
                                                                            {tipoInfo.icono}
                                                                        </div>
                                                                        <div>
                                                                            <div className="fw-medium text-dark">
                                                                                {doc.title}
                                                                            </div>
                                                                            {doc.obligatorio && (
                                                                                <Badge bg="danger" className="mt-1" pill size="sm">
                                                                                    Obligatorio
                                                                                </Badge>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="text-center py-3 px-3">
                                                                    <Badge
                                                                        bg={tipoInfo.color}
                                                                        className="d-flex align-items-center justify-content-center mx-auto"
                                                                        style={{ width: "fit-content", padding: "5px 8px" }}
                                                                        title={tipoInfo.texto}
                                                                    >
                                                                        {tipoInfo.icono}
                                                                    </Badge>
                                                                </td>
                                                                <td className="text-center py-3 px-3">
                                                                    <Form.Check
                                                                        type="switch"
                                                                        id={`obligatorio-${doc.id}`}
                                                                        checked={doc.obligatorio}
                                                                        onChange={(e) => handleObligatorioChange(doc.id, e.target.checked)}
                                                                    />
                                                                </td>
                                                                <td className="text-center py-3 px-3">
                                                                    <div className="d-flex justify-content-center gap-1">
                                                                        <OverlayTrigger
                                                                            placement="top"
                                                                            overlay={<Tooltip>Mover arriba</Tooltip>}
                                                                        >
                                                                            <Button
                                                                                variant="outline-secondary"
                                                                                size="sm"
                                                                                onClick={() => moverArriba(indexOriginal)}
                                                                                disabled={indexOriginal === 0}
                                                                                style={{ borderRadius: "6px" }}
                                                                            >
                                                                                <FaArrowUp />
                                                                            </Button>
                                                                        </OverlayTrigger>

                                                                        <OverlayTrigger
                                                                            placement="top"
                                                                            overlay={<Tooltip>Mover abajo</Tooltip>}
                                                                        >
                                                                            <Button
                                                                                variant="outline-secondary"
                                                                                size="sm"
                                                                                onClick={() => moverAbajo(indexOriginal)}
                                                                                disabled={indexOriginal === documentos.length - 1}
                                                                                style={{ borderRadius: "6px" }}
                                                                            >
                                                                                <FaArrowDown />
                                                                            </Button>
                                                                        </OverlayTrigger>

                                                                        <OverlayTrigger
                                                                            placement="top"
                                                                            overlay={<Tooltip>Editar documento</Tooltip>}
                                                                        >
                                                                            <Button
                                                                                variant="outline-primary"
                                                                                size="sm"
                                                                                onClick={() => editarDocumento(doc)}
                                                                                style={{ borderRadius: "6px" }}
                                                                            >
                                                                                <FaEdit />
                                                                            </Button>
                                                                        </OverlayTrigger>

                                                                        <OverlayTrigger
                                                                            placement="top"
                                                                            overlay={<Tooltip>Eliminar documento</Tooltip>}
                                                                        >
                                                                            <Button
                                                                                variant="outline-danger"
                                                                                size="sm"
                                                                                onClick={() => eliminarDocumento(doc.id)}
                                                                                style={{ borderRadius: "6px" }}
                                                                            >
                                                                                <FaTrash />
                                                                            </Button>
                                                                        </OverlayTrigger>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                    {documentosFiltrados.length === 0 && (
                                                        <tr>
                                                            <td colSpan="5" className="text-center py-5">
                                                                <div
                                                                    className="bg-light rounded-circle mx-auto mb-3"
                                                                    style={{
                                                                        width: "60px",
                                                                        height: "60px",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                    }}
                                                                >
                                                                    <FaInfoCircle size={24} className="text-muted" />
                                                                </div>
                                                                <h6 className="text-muted mb-2">Sin resultados</h6>
                                                                <p className="text-muted mb-0">
                                                                    No se encontraron documentos que coincidan con la búsqueda
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Card.Body>
                                </Card>

                                {/* Información */}
                                <Alert variant="info" className="border-0 shadow-sm" style={{ borderRadius: "10px" }}>
                                    <div className="d-flex align-items-start">
                                        <FaInfoCircle className="me-3 mt-1 fs-5" />
                                        <div>
                                            <h6 className="fw-bold mb-2">¿Cómo funcionan los tipos de documentos?</h6>
                                            <div className="small">
                                                <p className="mb-1">
                                                    <strong>Carga de documento:</strong> El usuario debe subir un archivo (PDF, imagen, etc.)
                                                </p>
                                                <p className="mb-1">
                                                    <strong>Firma digital:</strong> Se le enviará un documento al trabajador para que lo firme digitalmente.
                                                </p>
                                                <p className="mb-0">
                                                    <strong>Formulario para llenar:</strong> El trabajador deberá completar un formulario con campos específicos.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </Alert>
                            </>
                        )}
                    </Card.Body>
                </Card>
            </Container>

            {/* Modal para editar documento */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton className="border-0 pb-2">
                    <Modal.Title className="d-flex align-items-center">
                        <div
                            className="rounded-3 p-2 me-3"
                            style={{
                                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                color: "white",
                            }}
                        >
                            {documentoEditando ? <FaEdit /> : <FaPlus />}
                        </div>
                        <div>
                            {documentoEditando ? "Editar Documento" : "Agregar Documento"}
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-semibold">Nombre del Documento</Form.Label>
                            <Form.Control
                                type="text"
                                value={documentoEditando
                                    ? documentoEditando.title
                                    : nuevoDocumento.title}
                                onChange={(e) => {
                                    if (documentoEditando) {
                                        setDocumentoEditando({ ...documentoEditando, title: e.target.value });
                                    } else {
                                        setNuevoDocumento({ ...nuevoDocumento, title: e.target.value });
                                    }
                                }}
                                placeholder="Título del documento"
                                style={{ borderRadius: "10px" }}
                            />
                        </Form.Group>
                
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-semibold">Tipo de Documento</Form.Label>
                            <Form.Select
                                value={documentoEditando
                                    ? documentoEditando.type
                                    : nuevoDocumento.type}
                                onChange={(e) => {
                                    if (documentoEditando) {
                                        setDocumentoEditando({ ...documentoEditando, type: e.target.value });
                                    } else {
                                        setNuevoDocumento({ ...nuevoDocumento, type: e.target.value });
                                    }
                                }}
                                style={{ borderRadius: "10px" }}
                            >
                                {TIPOS_DOCUMENTO.map(tipo => (
                                    <option key={tipo.valor} value={tipo.valor}>
                                        {tipo.texto}
                                    </option>
                                ))}
                            </Form.Select>
                            <Form.Text className="text-muted">
                                Define si el usuario debe subir un documento o si el documento requiere firma digital.
                            </Form.Text>
                        </Form.Group>
                
                        <Form.Group className="mb-3">
                            <Form.Check
                                type="switch"
                                id="doc-obligatorio-modal"
                                label="Es un documento obligatorio"
                                checked={documentoEditando
                                    ? documentoEditando.obligatorio
                                    : nuevoDocumento.obligatorio}
                                onChange={(e) => {
                                    if (documentoEditando) {
                                        setDocumentoEditando({ ...documentoEditando, obligatorio: e.target.checked });
                                    } else {
                                        setNuevoDocumento({ ...nuevoDocumento, obligatorio: e.target.checked });
                                    }
                                }}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="border-0 pt-0">
                    <Button
                        variant="primary"
                        onClick={() => {
                            if (documentoEditando) {
                                guardarEdicion();
                            } else {
                                // Agregar documento desde el modal
                                if (!nuevoDocumento.title.trim()) {
                                    setError("El nombre del documento no puede estar vacío");
                                    return;
                                }
                                const nuevoId = (documentos.length + 1).toString();
                                const nuevoDoc = {
                                    id: nuevoId,
                                    title: nuevoDocumento.title,
                                    obligatorio: nuevoDocumento.obligatorio,
                                    activo: true,
                                    type: nuevoDocumento.type
                                };
                                setDocumentos([...documentos, nuevoDoc]);
                                setNuevoDocumento({ title: "", obligatorio: true, type: "upload" });
                                setDocumentosModificados(true);
                                setShowModal(false);
                                Swal.fire({
                                    title: "Documento agregado",
                                    text: "El documento se agregó a la lista",
                                    icon: "success",
                                    timer: 1500,
                                    showConfirmButton: false
                                });
                            }
                        }}
                        style={{
                            borderRadius: "8px",
                            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                            border: "none",
                        }}
                    >
                        <FaCheckCircle className="me-2" />
                        Guardar
                    </Button>
                    <Button
                        variant="outline-secondary"
                        onClick={() => setShowModal(false)}
                        style={{ borderRadius: "8px" }}
                    >
                        Cancelar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default ListaMaestra;


